export const ROLE = {
  master: 1,
  creative: 2,
  normal: 3,
  light: 4,
  lowest: 5,
};

export const CLASSIFICATION = {
  high_school: "高校",
  junior_high_school: "中学",
  other_school: "その他",
};

export const APP = {
  dlp: "DLP",
  g4s: "GearForSchool",
};

export const MIN_ENTRANCE_YEAR = 2018;

export const MAX_ENTRANCE_YEAR = new Date().getFullYear() + 1;

export const IMAGE_TYPE = {
  vertical: 1,
  horizontal: 2,
};
